import React from 'react';
import Alert from 'antd/lib/alert';
import 'antd/lib/alert/style/index.css';
import Icon from 'antd/lib/icon';
var selfStyles = require('./styles.scss');
var AlertScoresFinalized = function (props) { return (props.isScoresFinalized
    ? (React.createElement(Alert, { className: selfStyles.alert, type: 'success', message: React.createElement("span", null,
            React.createElement(Icon, { type: 'check-circle', className: selfStyles.iconPositive }),
            " Scores are verified"), description: 'The Chief Judge has validated and signed off the scores for this round' }))
    : (React.createElement(Alert, { className: selfStyles.alert, type: 'warning', message: React.createElement("span", null,
            React.createElement(Icon, { type: 'sync', className: selfStyles.icon, style: { animation: 'loadingCircle 2s infinite linear' } }),
            " Scores are ",
            React.createElement("strong", null, "NOT"),
            " final"), description: 'The Chief Judge has not verified the scores for this round. Scores shown here are subjected to changes.' }))); };
export default AlertScoresFinalized;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/AlertScoresFinalized.tsx
// module id = 415
// module chunks = 0